import { useCarouselContext } from '../context';

export function TotalSumsArea() {
  const context = useCarouselContext();
  const lens = context.lens;
  const Component = lens.TotalSumsArea;
  return Component ? <Component /> : <></>;
}
